const module = {
  config: {
    name: "master",
    svg: "../static/img/icon/menu/master.svg",
    desc: "Berisi modul master data untuk kebutuhan data transaksi",
    layout: true,
  },
  routes: [
    // perencanaan-produksi-bibit
    {
      name: "Produksi Bibit",
      icon: "ri-brain-line",
      path: "/perencanaan-produksi-bibit",
      component: () => import("./perencanaan/produksi-bibit/index.vue"),
      separator: "Perencanaan",
    },
    // location-nursery
    {
      name: "Lokasi Persemaian",
      icon: "ri-map-pin-line",
      path: "/location-nursery",
      component: () => import("./nursery/location-nursery.vue"),
      separator: "Perencanaan",
    },
    // block-nursery
    {
      name: "Blok Persemaian",
      icon: "ri-map-2-fill",
      path: "/block-nursery",
      component: () => import("./nursery/block-nursery.vue"),
      separator: "Lokasi",
    },
    // bedeng-nursery
    {
      name: "Bedeng Persemaian",
      icon: "ri-barricade-fill",
      path: "/bedeng-nursery",
      component: () => import("./nursery/bedeng-nursery.vue"),
      separator: "Lokasi",
    },
    // vendor-freelance
    {
      name: "Pekerja Lepas",
      icon: "ri-team-line",
      path: "/vendor-freelance",
      component: () => import("./vendor/freelance.vue"),
      separator: "Pekerja",
    },
    // vendor-transportation
    {
      name: "Vendor Transportasi",
      icon: "ri-truck-line",
      path: "/vendor-transportation",
      component: () => import("./vendor/transportation.vue"),
      separator: "Daftar Vendor",
    },
    // trees-vendor
    {
      name: "Vendor Bibit",
      icon: "ri-building-2-line",
      path: "/trees-vendor",
      component: () => import("./trees/vendor/index.vue"),
      separator: "Daftar Vendor",
    },
    // vendor-sarpras
    {
      name: "Vendor Sarpras",
      icon: "ri-tools-line",
      path: "/vendor-sarpras",
      component: () => import("./vendor/sarpras.vue"),
      separator: "Daftar Vendor",
    },
    // master-vehicle-internal
    {
      name: "Kendaraan Internal",
      icon: "ri-car-line",
      path: "/master-vehicle-internal",
      component: () => import("./assets/vehicle-internal.vue"),
      separator: "Assets",
    },
    // trees-main
    {
      name: "Plant Library",
      icon: "ri-plant-line",
      path: "/trees-main",
      component: () => import("./trees/main.vue"),
      separator: "Tanaman",
    },
    // trees-part
    {
      name: "Bagian Tanaman",
      icon: "ri-node-tree",
      path: "/trees-part",
      component: () => import("./trees/part-tree.vue"),
      separator: "Tanaman",
    },
    // trees-type
    {
      name: "Tipe Tanaman",
      icon: "ri-leaf-line",
      path: "/trees-type",
      component: () => import("./trees/type.vue"),
      separator: "Tanaman",
    },
    // trees-pest
    {
      name: "Hama",
      icon: "ri-bug-line",
      path: "/trees-pest",
      component: () => import("./trees/pest.vue"),
      separator: "Tanaman",
    },
    // trees-plant-disease
    {
      name: "Penyakit",
      icon: "ri-virus-line",
      path: "/trees-plant-disease",
      component: () => import("./trees/plant-disease.vue"),
      separator: "Tanaman",
    },
    // trees/treatment-skill
    {
      name: "Perlakuan & Perawatan",
      icon: "ri-robot-line",
      path: "/trees/treatment-skill",
      component: () => import("./trees/treatment-skill.vue"),
      separator: "Benih & Bibit",
    },
    // trees/unit-seed
    {
      name: "Satuan Unit Benih",
      icon: "ri-dropbox-line",
      path: "/trees/unit-seed",
      component: () => import("./trees/unit-seed.vue"),
      separator: "Benih & Bibit",
    },
    // monitoring-reason
    {
      name: "Kategori Masalah",
      icon: "ri-dropbox-line",
      path: "/monitoring-reason",
      component: () => import("./monitoring/reason-maintenance.vue"),
      separator: "Monitoring",
    },
    // master-material
    {
      name: "Pestisida, Nutrisi & Pupuk",
      icon: "ri-dropbox-line",
      path: "/master-material",
      component: () => import("./material/material.vue"),
      separator: "Material",
    },
    // trees-allocation-bag
    {
      name: "Kapasitas Bibit Per Bag",
      icon: "ri-building-3-line",
      path: "/trees-allocation-bag",
      component: () => import("./trees/allocation-bag.vue"),
      separator: "Distribusi",
    },
    // working-area-management-unit
    {
      name: "Management Unit",
      icon: "ri-road-map-line",
      path: "/working-area-management-unit",
      component: () => import("./working-area/management-unit.vue"),
      separator: "Area Kerja",
    },
    // master-sponsor
    {
      name: "Sponsor",
      icon: "ri-money-dollar-circle-line",
      path: "/master-sponsor",
      component: () => import("./project/sponsor.vue"),
      separator: "Projek Penanaman",
    },
    // master-custom-project
    {
      name: "Project",
      icon: "ri-patreon-line",
      path: "/master-custom-project",
      component: () => import("./project/custom-project.vue"),
      separator: "Projek Penanaman",
    },
    // sarpras-category-pengadaan
    {
      name: "Kategori",
      icon: "ri-instance-line",
      path: "/sarpras-category-pengadaan",
      component: () => import("./sarpras/pengadaan/category-pengadaan.vue"),
      separator: "Pengadaan Sarpras",
    },
    // sarpras-barang-pengadaan
    {
      name: "Jenis Kegiatan",
      icon: "ri-archive-2-line",
      path: "/sarpras-barang-pengadaan",
      component: () => import("./sarpras/pengadaan/item-pengadaan.vue"),
      separator: "Pengadaan Sarpras",
    },
    // sarpras-satuan-pengadaan
    // {
    //   name: "Satuan",
    //   icon: "ri-instance-line",
    //   path: "/sarpras-satuan-pengadaan",
    //   component: () => import("./sarpras/pengadaan/satuan-pengadaan.vue"),
    //   separator: "Pengadaan Sarpras"
    // },
  ],
};
export default module;



// WEBPACK FOOTER //
// ./src/modules/master/_index.js